module.exports = __webpack_public_path__ + "img/gn_08.1a06486c.png";